export enum VehicleListMode {
  SUBSCRIBED = 'SUBSCRIBED',
  ALL = 'ALL'
}
